export default __webpack_public_path__ + "static/media/voucher.ba7c0d7a.svg";